export default {
  title: "[[cr]]",
  number: "Nr.",
  general: {
    lastPrintedAt: "Zuletzt gedruckt",
  },
  form: {
    general: {
      date: "Datum",
      edit: "Bearbeiten",
      save: "Speichern",
      cancel: "Abbrechen",
      add_hint: "Strg + Enter zum Hinzufügen",
      comment_title: "Bemerkungen",
      comment: "Bemerkung",
      add_comment: "Hinzufügen",
      remove_comment: "Entfernen",
      occurrence_title: "Besondere Vorkommnisse",
      occurrence: "Besondere Vorkommnisse",
      add_occurrence: "Hinzufügen",
      remove_occurrence: "Entfernen",
    },
    shift: {
      title: "Neue Schicht Hinzufügen",
      add_shift: "Hinzufügen",
      edit_shift: "Bearbeiten",
      crew: "Team & Geräte",
      list_title: "Schichten",
      new_shift: "Neue Schicht",
      when: "Zeit",
      fromTime: "Von Uhrzeit",
      toTime: "Bis Uhrzeit",
      resources: {
        people: "Personal",
        machines: "Geräte",
        materials: "Material",
      },
      weather: {
        title: "Wetter",
        loading: "Wetter wird geladen…",
        adjust: "Anpassen",
        done: "Fertig",
        manual_hint: "Wetter konnte nicht automatisch geladen werden. Bitte manuell eingeben.",
        start: "Anfang",
        mid: "Mitte",
        end: "Ende",
        time: "Uhrzeit",
        temperature: "Temperatur",
        weather: "Wetter",
        // Über dem Wetter der Schicht Stunde für Stunde, unter den drei Angaben.
        course: "Wetterverlauf",
      },
      user: {
        input: "Projekt-personal",
        title: "Personal hinzufügen",
        user: "Personal",
        position: "Position",
        no_positions: "Keine Positionen verfügbar",
        from_project: "Projekt",
        assigned: "Zugewiesen",
        // Beim Speichern übernimmt der Server die Position ins Projekt — ohne Stundensatz, denn
        // der ist eine kaufmännische Entscheidung. Den fehlenden Satz meldet der Reiter im Projekt.
        not_in_project: "Neu im Projekt.",
        headers: {
          name: "Name",
          position: "Position",
        },
      },
      machine: {
        input: "Projekt-Geräte",
        title: "Gerät hinzufügen",
        machine: "Gerät",
        identifier: "Geräte-Nummer",
        no_identifiers: "Keine Geräte-Nummern verfügbar",
        follows_shift: "Gemäß Schichtzeit eingesetzt",
        follows_shift_hint: "Die Arbeitszeit der Schicht ({hours} h) zählt als Einsatzzeit",
        follows_shift_hint_unset: "Die Arbeitszeit der Schicht zählt als Einsatzzeit",
        hours: "Einsatzstunden",
        hours_max: "Höchstens die Arbeitszeit der Schicht ({hours} h)",
        hours_positive: "Mehr als 0 Stunden",
        edit_hours: "Einsatzzeit ändern",
        deviating_hours: "{hours} h",
        duplicate_device: "Schon in dieser Schicht: Geräte-Nr. {devices}.",
        headers: {
          name: "Name",
          identifier: "Geräte-Nummer",
        },
      },
      material: {
        input: "Projekt-Materialien",
        title: "Material hinzufügen",
        material: "Material",
        amount: "Menge",
        headers: {
          name: "Name",
          amount: "Menge",
        },
      },
      break: {
        title: "Pausen",
        add: "Pause hinzufügen",
        fromTime: "Von Uhrzeit",
        toTime: "Bis Uhrzeit",
        remove_break: "Entfernen",
        add_break: "Hinzufügen",
        from: "Von",
        until: "Bis",
        error: "Pausenzeiten müssen zwischen der 'von' und 'bis' Uhrzeit liegen.",
        durationError: "Die Summe der Pausen darf die Dauer der Schicht nicht überschreiten.",
      },
    },
    service: {
      title: "Neue Leistung",
      edit_service: "Leistung bearbeiten",
      add_hint: "Strg + Enter zum Hinzufügen",
      positionIdentifier: "Pos. Nr. LV",
      description: "Leistungsbezeichnung",
      amount: "Menge",
      unit: "Einheit",
      add_service: "Hinzufügen",
      remove_service: "Entfernen",
      list_title: "Leistungen",
    },
    actions: {
      save: "Speichern",
      cancel: "Abbrechen",
    },
  },
  // Leistungen im Bautagesbericht: gebuchte Positionen des Leistungskatalogs.
  serviceEntries: {
    loading: "Lade Leistungskatalog…",
    empty: "Für dieses Projekt ist kein Leistungskatalog hinterlegt.",
    empty_hint:
      "Legen Sie Titel und Positionen im Projekt-Tab „Leistungskatalog“ an oder importieren Sie das Angebots-LV. Freie Leistungen können Sie unten trotzdem eintragen.",
    add: "Leistung buchen",
    search: "Position suchen (Pos-Nr., Kurztext, Titel)",
    before: "bisher {done} von {planned}",
    list_title: "Heute erbracht",
    position: "Position",
    quantity: "Menge",
    share: "Kostenanteil",
    note: "Notiz",
    add_note: "Notiz hinzufügen",
    remove: "Entfernen",
    take_rest: "Rest übernehmen",
    stat_before: "Bisher",
    details: "Details",
    rest_short: "Rest {rest}",
    done: "fertig",
    stat_planned: "LV-Menge",
    position_deleted: "Position wurde aus dem Leistungskatalog gelöscht",
    covered_by_stand: "Im Leistungsstand vom {date} enthalten, ändert das Ist nicht.",
    excess: "Damit wird die LV-Menge um {amount} überschritten (Mehrmenge).",
    quantity_required: "Menge eingeben",
    quantity_invalid: "Menge größer als 0 eingeben",
    rest_column: "Rest",
    flat_rate_share: "{share} % der Pauschale",
    quantity_too_large: "Diese Menge ist zu groß",
    quantity_unreadable: "Gültige Zahl oder Rechnung eingeben",
    quantity_info: "Auch Rechnungen, z. B. 12,5+7,5+3 oder 3,5x2,4",
    share_required: "Kostenanteil eingeben",
    share_range: "Kostenanteil zwischen 0 und 100 % eingeben",
    // Freie Leistungen: Freitext ohne Position, nie bepreist (constructionServices).
    free: {
      title: "Freie Leistungen",
      info: "Ohne Bezug zum Leistungskatalog: Diese Einträge werden mit [[cr:dem/der/dem]] [[cr]] gedruckt, zählen aber nicht zum Leistungsstand, zur Abrechnung oder zur Kostenaufteilung.",
      compose: "Leistung beschreiben",
      add: "Hinzufügen",
      hint: "Enter zum Hinzufügen · Umschalt + Enter für eine neue Zeile",
    },
    split: {
      title: "Kostenaufteilung",
      AUTO: "Automatisch",
      MANUAL: "Manuell",
      auto_hint: "Nach Leistungswert (Menge × Einzelpreis); ohne Preise gleichmäßig.",
      manual_hint:
        "Wie sich die Kosten dieses Berichts (Personal, Maschinen, Material) auf die Positionen verteilen. Unabhängig von der Menge: Wie viel erbracht wurde, steht im Feld Menge.",
      sum: "Summe {sum} %",
      equal: "Gleichmäßig verteilen",
    },
    quick_create: {
      button: "Position fehlt?",
      title: "Nachtragsposition anlegen",
      hint: "Für Arbeit, die nicht im Angebot steht: Die Position wird einem Nachtrag zugeordnet und kann sofort gebucht werden.",
      change_order: "Nachtrag",
      change_order_hint: "Bestehenden wählen oder leer lassen für einen neuen, beantragten Nachtrag.",
    },
  },
  tabs: {
    general: "Allgemein",
    shift: "Schichten",
    services: "Leistungen",
    files: "Dateien",
    activity: "Protokoll",
  },
  validation: {
    atLeastOneShift: "Mindestens eine <strong>Schicht</strong> muss existieren",
    atLeastOneCommentOrOccurrenceOrService: "Mindestens eine Bemerkung, Leistung oder besonderes Vorkommnis",
    serviceEntries: "Bei den <strong>Leistungen</strong> fehlt eine Menge, oder die Kostenanteile ergeben nicht 100 %",
    atLeastOneUserOrMachine: "Mindestens ein Personal oder eine Machine",
    machineHoursExceedShift: "Die Einsatzstunden eines Geräts überschreiten die Arbeitszeit der Schicht",
  },
}
